import {
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE,

    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS,
    CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterTubeSizeAndPatterns: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERNS_FAILURE:
                return []
            default:
                return state
        }
    },
    masterTubeSizeAndPattern: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_TUBE_SIZE_AND_PATTERN_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/tubeSizeAndPattern.js